// extracted by mini-css-extract-plugin
export var aniSpin = "x_d";
export var base = "x_R";
export var base__bg = "x_S";
export var base__frame = "x_T";
export var el = "x_b";
export var icon = "x_V";